import React, { useEffect, useRef, useState } from 'react';
import './presentation-theme.css';
import './SlideStage.css';

const DESIGN_W = 1280;
const DESIGN_H = 720;

// Scale a fixed 1280x720 HTML slide into any viewer without changing the
// authored layout.
export default function SlideStage({ children, className = '' }) {
  const outerRef = useRef(null);
  const innerRef = useRef(null);
  const [scale, setScale] = useState(1);

  useEffect(() => {
    const element = outerRef.current;
    if (!element) return undefined;
    const compute = () => {
      const { width, height } = element.getBoundingClientRect();
      if (width && height) setScale(Math.min(width / DESIGN_W, height / DESIGN_H));
    };
    compute();
    const observer = new ResizeObserver(compute);
    observer.observe(element);
    return () => observer.disconnect();
  }, []);

  return (
    <div ref={outerRef} className={`slide-stage ${className}`}>
      <div ref={innerRef} className="slide-stage-inner" style={{ transform: `scale(${scale})` }}>
        {children}
      </div>
    </div>
  );
}
